<template>
    <div class="delete-account-form">
        <form @submit.prevent="deleteAccount" class="delete-account-form-container">
            <h2>{{ $t('Вы уверенны') }}</h2>

            <div class="alert alert-danger">
                {{ $t('Если вы не прочитаете это, произойдут неожиданные неприятности') }}
            </div>
            <p v-html="$t('profile_delete_warning_one')"></p>
            <p class="info-tip">{{ $t('profile_delete_warning_two') }}</p>
            <p>
                {{ $t('profile_delete_warning_three') }}
            </p>

            <button type="submit" class="btn btn-form btn-blue">{{ $t('Я понимаю последствия, удалить профиль') }}</button>
        </form>
    </div>
</template>

<script>
import { EventBus } from '../../../../event-bus';

export default {
    name: "DeleteAccount",

    props: ['isSideForm'],

	data: function() {
        return {
            errors: {},
        };
    },

    methods: {
        deleteAccount() {
            axios.post('/settings/delete')
                .then(({data}) => {
                    EventBus.$emit('close-side-form');

                    this.$store.commit('logout');
                    
                    localStorage.removeItem('token');

                    delete axios.defaults.headers.common['Authorization'];

                    location.href = '/login';

                    EventBus.$emit('account-deleted');

                    this.$ga.event('deleteAccount', 'deleted');

                    EventBus.$emit('show-alert', data.message, 'success');
                }).catch(({response}) => {
                    console.log(response);
                            
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error')
                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
}
</script>

<style scoped lang="scss">
.delete-account-form {
    .delete-account-form-container {
        background: #fff;
        width: calc(100% - 64px);
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        @media (max-width: 768px) {
            background: transparent;
            padding: 0 24px;
            width: calc(100% - 48px);
            display: flex;
            flex-direction: column;
            height: 100%;

            .btn-form {
                margin-top: auto;
                margin-bottom: 24px;
            }
        }

        h2 {
            color: #152640;
            font-family: "Proxima Nova Lt";
            font-weight: 600;
            font-size: 18px;
            margin: 0;
            margin-bottom: 24px;
        }
    }

    .info-tip {
        font-size: 12px;
        font-family: 'Proxima Nova Rg';
        color: rgba(#152640, .5);
    }
}
</style>